var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 512,
    viewBox: "0 0 513 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M462.717 370.083L426.862 304.334V189.888C427.326 144.542 410.089 100.804 378.815 67.9657C347.541 35.1276 304.695 15.7785 259.382 14.0297C236.703 13.6063 214.167 17.708 193.091 26.095C172.016 34.4821 152.824 46.9862 136.637 62.8764C120.45 78.7666 107.594 97.7241 98.8182 118.641C90.0429 139.557 85.5252 162.014 85.5291 184.696V304.334L49.6749 370.069C46.4986 375.876 44.8895 382.411 45.0059 389.029C45.1223 395.647 46.9602 402.121 50.3388 407.813C53.7173 413.505 58.5199 418.219 64.2739 421.492C70.0278 424.764 76.5347 426.481 83.154 426.474H429.238C435.855 426.48 442.359 424.762 448.111 421.491C453.863 418.219 458.665 413.507 462.043 407.817C465.421 402.127 467.26 395.655 467.378 389.039C467.496 382.423 465.889 375.89 462.717 370.083ZM256.196 497.585C271.155 497.565 285.847 493.612 298.797 486.124C311.747 478.635 322.501 467.874 329.981 454.919H182.411C189.891 467.874 200.645 478.635 213.595 486.124C226.545 493.612 241.236 497.565 256.196 497.585Z",
    fill: "#FF5722"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationManagement);
export default __webpack_public_path__ + "static/media/Notification-management.e7975e3a0407821b439633458e628565.svg";
export { ForwardRef as ReactComponent };